import { getRequest } from "./requester";
import { enqueueSnackbar } from "notistack";

export const getProfessions = async () => {
  try {
    const consulta = `/buscar?tipo=profesiones`;
    const response = await getRequest(consulta);
    if (response.s === "OK") {
      return response.d;
    } else {
      enqueueSnackbar(response.m, {
        variant: "error",
        autoHideDuration: null,
      });
    }
  } catch (error) {
    console.error(error);
    enqueueSnackbar(error, {
      variant: "error",
      autoHideDuration: null,
    });
  }
};
